
import HTMLReactParser from "html-react-parser";
import { removeTags } from "../utils";
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useState } from 'react';
import { Check, ExternalLink, Copy } from 'lucide-react';

export const GroupListSection = ({ groupName, cibleList, currentEvent, formulaireList, ownerIdContact, formulaireEventList }) => {
    const [copiedId, setCopiedId] = useState(null);

    const handleCopy = (url, id) => {
        navigator.clipboard.writeText(url);
        setCopiedId(id);
        setTimeout(() => setCopiedId(null), 2000);
    };

    if (!currentEvent) {
        return <div className="text-gray-500 dark:text-neutral-400 p-4">Chargement...</div>;
    }

    return (
        <div className="mx-0 md:mx-2">
            {groupName && (
                <h2 className="text-xl md:text-2xl font-extrabold my-6 text-gray-800 dark:text-white tracking-tight">
                    {groupName}
                </h2>
            )}

            {cibleList.map(cible => (
                <section
                    key={cible.cibleName}
                    className="mb-6 p-3 md:p-5 border border-gray-200 dark:border-neutral-800 rounded-2xl bg-white dark:bg-neutral-900"
                >
                    {cible.cibleName && (
                        <div className="mb-3 pb-2 border-b border-gray-100 dark:border-neutral-800">
                            <h3 className="text-base md:text-lg font-semibold text-gray-700 dark:text-neutral-200">
                                {HTMLReactParser(cible.cibleName)}
                            </h3>
                        </div>
                    )}

                    <div className="space-y-6">
                        {cible.cibleCategory.map(category => (
                            <div key={category.cibleCategoryName}>
                                <h4 className="font-bold text-gray-600 dark:text-neutral-300 mb-3 text-sm md:text-base">
                                    {HTMLReactParser(category.cibleCategoryName)}
                                </h4>
                                <div className="space-y-3">
                                    {formulaireList && formulaireList
                                        .filter(f => category.formulaireIds.includes(f.id_formulaire.toString()))
                                        .map(formulaire => {
                                            const linkUrl = `/events/${currentEvent.id_event}/signup/${formulaire.route}/?form-name=${formulaire.route}&formisvisible=1&id_formulaire=${formulaire.id_formulaire}&auteur=${ownerIdContact}`;

                                            const formulaireEvent = formulaireEventList
                                                ? formulaireEventList.find(fe =>
                                                    fe.id_formulaire.id_formulaire === formulaire.id_formulaire &&
                                                    fe.id_event.id_event === currentEvent.id_event)
                                                : null;

                                            const visuel = formulaireEvent?.visuel_event_thumbs?.small || formulaire.visuels?.small;
                                            const nom = formulaireEvent?.name_event || formulaire.name;
                                            const nomCourt = formulaireEvent?.name_short_event;
                                            const titre = formulaireEvent?.page_title_event || formulaire.page_title;

                                            return (
                                                <div
                                                    key={formulaire.id_formulaire}
                                                    className="flex flex-col sm:flex-row items-start sm:items-stretch bg-gray-50 dark:bg-neutral-800 hover:bg-gray-100 dark:hover:bg-neutral-700 transition rounded-xl border border-gray-200 dark:border-neutral-700 p-3 md:p-4 gap-3 md:gap-5 shadow-sm"
                                                >
                                                    {/* Visuel */}

                                                    <div className="flex-shrink-0 flex flex-col items-center gap-1">
                                                        <div className="w-16 h-16 md:w-20 md:h-20 bg-white dark:bg-neutral-900 border border-gray-200 dark:border-neutral-600 rounded-lg flex items-center justify-center text-gray-400 dark:text-neutral-500 text-xs font-medium overflow-hidden">
                                                            {visuel ? (
                                                                <img src={visuel} alt="" className="object-contain w-full h-full rounded-lg" />
                                                            ) : (
                                                                <span className="text-center leading-tight">visuel<br />principal</span>
                                                            )}
                                                        </div>
                                                        <span className="text-xs text-gray-400 dark:text-neutral-500 font-mono">#{formulaire.id_formulaire}</span>
                                                    </div>

                                                    {/* Titre & contexte */}
                                                    <div className="flex-1 flex flex-col justify-center min-w-0">
                                                        {(nom || nomCourt) && (
                                                            <div className="text-sm text-gray-500 dark:text-neutral-400 mb-0.5">
                                                                {nom}
                                                                {nomCourt && (
                                                                    <span
                                                                        className="ml-1 font-medium text-green-700 dark:text-green-400"
                                                                        title="Nom court personnalisé pour cet événement">
                                                                        « {nomCourt} »
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )}
                                                        {titre && <div className="uppercase font-bold text-gray-800 dark:text-white mb-1 text-sm md:text-base">{titre}</div>}
                                                        <div className="text-gray-500 dark:text-neutral-400 text-sm line-clamp-2">
                                                            {HTMLReactParser(removeTags(formulaire.contexte_utilisation ?? ''))}
                                                        </div>
                                                    </div>

                                                    {/* Actions */}
                                                    <div className="flex flex-row sm:flex-col gap-2 w-full sm:w-auto mt-1 sm:mt-0 shrink-0">
                                                        <Link
                                                            to={linkUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-white dark:bg-neutral-900 border border-gray-200 dark:border-neutral-700 text-gray-700 dark:text-neutral-200 text-sm hover:bg-blue-50 dark:hover:bg-blue-950 hover:border-blue-400 hover:text-blue-700 dark:hover:text-blue-400 transition shadow-sm whitespace-nowrap"
                                                        >
                                                            <ExternalLink size={14} />
                                                            Afficher
                                                        </Link>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleCopy(window.location.origin + linkUrl, formulaire.id_formulaire)}
                                                            className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-white dark:bg-neutral-900 border border-gray-200 dark:border-neutral-700 text-gray-700 dark:text-neutral-200 text-sm hover:bg-green-50 dark:hover:bg-green-950 hover:border-green-400 hover:text-green-700 dark:hover:text-green-400 transition shadow-sm whitespace-nowrap min-w-[110px]"
                                                        >
                                                            {copiedId === formulaire.id_formulaire ? (
                                                                <span className="flex items-center gap-1.5 text-green-600 dark:text-green-400 font-bold">
                                                                    <Check size={14} /> Copié !
                                                                </span>
                                                            ) : (
                                                                <><Copy size={14} /> Copier le lien</>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            ))
            }
        </div >
    );
}



export const FormulaireListSection = ({ currentEvent, formulaireList, title, description, ownerIdContact }) => {
    const [copiedId, setCopiedId] = useState(null);

    const handleCopy = (url, id) => {
        navigator.clipboard.writeText(url);
        setCopiedId(id);
        setTimeout(() => setCopiedId(null), 2000);
    };

    return (
        <div className="max-w-4xl mx-auto">
            <h2 className="font-bold text-xl md:text-2xl my-6 text-gray-700 dark:text-white">{title}</h2>
            {description && <p className="pb-4 text-gray-500 dark:text-neutral-400 text-sm md:text-base">{description}</p>}
            <div className="space-y-4">
                {formulaireList && formulaireList.map(formulaire => {
                    const linkUrl = `/events/${currentEvent.id_event}/signup/${formulaire.route}/?form-name=${formulaire.route}&formisvisible=1&id_formulaire=${formulaire.id_formulaire}&auteur=${ownerIdContact}`;
                    return (
                        <div
                            key={formulaire.id_formulaire}
                            className="flex flex-col sm:flex-row items-start sm:items-stretch bg-white dark:bg-neutral-900 rounded-xl border border-gray-200 dark:border-neutral-800 shadow-sm p-3 md:p-4 gap-3 md:gap-4"
                        >
                            {/* Visuel */}
                            <div className="flex-shrink-0 flex flex-col items-center gap-1">
                                <div className="w-16 h-16 md:w-24 md:h-24 bg-gray-100 dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-md flex items-center justify-center text-gray-400 dark:text-neutral-500 text-xs font-medium overflow-hidden">
                                    {formulaire.visuels?.small ? (
                                        <img src={formulaire.visuels.small} alt="" className="object-contain w-full h-full rounded-md" />
                                    ) : (
                                        <span className="text-center leading-tight">visuel<br />principal</span>
                                    )}
                                </div>
                                <span className="text-xs text-gray-400 dark:text-neutral-500 font-mono">#{formulaire.id_formulaire}</span>
                            </div>

                            {/* Titre & contexte */}
                            <div className="flex-1 flex flex-col justify-center min-w-0">
                                <div className="font-bold text-base md:text-lg text-gray-800 dark:text-white truncate">{formulaire.name}</div>
                                <div className="text-gray-500 dark:text-neutral-400 text-sm md:text-base truncate">
                                    {HTMLReactParser(removeTags(formulaire.contexte_utilisation ?? ''))}
                                </div>
                            </div>

                            {/* Actions */}
                            <div className="flex flex-row sm:flex-col gap-2 w-full sm:w-auto shrink-0">
                                <Link
                                    to={linkUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-gray-100 dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 text-gray-700 dark:text-neutral-200 text-sm font-semibold hover:bg-gray-200 dark:hover:bg-neutral-700 transition whitespace-nowrap"
                                >
                                    <ExternalLink size={14} /> Consulter
                                </Link>
                                <button
                                    type="button"
                                    onClick={() => handleCopy(window.location.origin + linkUrl, formulaire.id_formulaire)}
                                    className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-gray-100 dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 text-gray-700 dark:text-neutral-200 text-sm font-semibold hover:bg-gray-200 dark:hover:bg-neutral-700 transition min-w-[110px] whitespace-nowrap"
                                >
                                    {copiedId === formulaire.id_formulaire ? (
                                        <span className="flex items-center gap-1.5 text-green-600 dark:text-green-400 font-bold">
                                            <Check size={14} /> Copié !
                                        </span>
                                    ) : (
                                        <><Copy size={14} /> Copier le lien</>
                                    )}
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
